import { useEffect } from 'react';
import AccountManager from 'react-native-account-manager';
import { useRecoilState } from 'recoil';

import { userEmailState } from '@store';

import { isAndroid, isX1 } from '../helpers/Platform';

export const useGetUserEmail = () => {
  const [email, setEmail] = useRecoilState(userEmailState);

  useEffect(() => {
    if (email) {
      return email;
    }
    if (isX1) {
      window.$badger
        .userPreferences()
        .promptSignUpEmail()
        .success(({ status, data }) => {
          console.log(`X1 email prompt success. Status: ${status}`);
          if (status === 'SUCCESS') {
            setEmail(data.email);
          }
        })
        .failure(({ message }) => {
          console.log(`X1 email prompt failure. Reason: ${message}`);
          return null;
        });
    } else if (isAndroid) {
      AccountManager.getAccountsByType(null).then(accounts => {
        const [firstAccount] = accounts;

        console.log(`Found account with name: ${firstAccount}`);
        const name = firstAccount?.name;
        const emailPattern = /^[\w.-]+@[\d.A-Za-z-]+\.[A-Za-z]{2,4}$/;

        if (name && emailPattern.test(name)) {
          setEmail(name);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  return email;
};
